import { SxProps, Theme } from '@mui/material';

type TStyles = {
  invalidSessionContainer: SxProps<Theme>;
  invalidSessionBlock: SxProps<Theme>;
  invalidSessionHeader: SxProps<Theme>;
  invalidSessionContent: SxProps<Theme>;
  textContainer: SxProps<Theme>;
  text: SxProps<Theme>;
};

export const styles: TStyles = {
  invalidSessionContainer: {
    width: '100vw',
    height: '100vh',
    display: 'grid',
    placeItems: 'center',
    letterSpacing: '-1.5px',
  },

  invalidSessionBlock: (theme: Theme) => ({
    width: '50%',
    height: 'auto',
    padding: '30px 45px 30px',
    boxSizing: 'border-box',
    borderRadius: '18px',
    boxShadow: '7px 7px 40px 0 rgba(217, 217, 217, 0.8)',
    [theme.breakpoints.down('md')]: {
      width: '70%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      padding: '25px',
      letterSpacing: '-0.6px',
    },
  }),

  invalidSessionHeader: (theme: Theme) => ({
    color: theme.palette.primary.main,
    textAlign: 'center',
    paddingBottom: 2,
    lineHeight: '10px',
    fontSize: '25px',
    fontWeight: 700,
    [theme.breakpoints.down('md')]: {
      lineHeight: '25px',
      fontSize: '25px',
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '5px',
      lineHeight: '10px',
      fontSize: '16px',
    },
  }),

  invalidSessionContent: {
    color: 'text.primary',
    fontFamily: '"Nunito Sans", sans-serif',
    fontWeight: 400,
    textAlign: 'justify',
    alignItems: 'flex-start',
  },

  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
  },

  text: (theme: Theme) => ({
    fontSize: '14px',
    lineHeight: '19px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
      lineHeight: '14px',
    },
  }),
};
